import { Helmet } from 'react-helmet-async';

import Landing from 'organisms/Landing';

import ServiceInfo from './ServiceInfo';

export default function AddServiceOptional() {
  return (
    <>
      <Helmet title="Add service | PawCare" />
      <Landing
        title="Services and prices"
        text="Help pet parents book with ease by having a full price list"
      >
        <ServiceInfo />
      </Landing>
    </>
  );
}
